// Account onboarding needs ads and Page reads. Publishing/Instagram permissions
// are separate capabilities and may not be enabled for the configured Meta app.
const FACEBOOK_ACCOUNT_SCOPES = [
  'ads_read', 'ads_management', 'pages_read_engagement', 'pages_show_list',
];

export function createFacebookAuthorizationUrl(appId: string, origin: string): string {
  const url = new URL('https://www.facebook.com/v25.0/dialog/oauth');
  url.searchParams.set('client_id', appId);
  url.searchParams.set('redirect_uri', `${origin}/facebook-callback.html`);
  url.searchParams.set('scope', FACEBOOK_ACCOUNT_SCOPES.join(','));
  url.searchParams.set('response_type', 'code');
  return url.toString();
}

interface FacebookOAuthResult {
  type: 'facebook-oauth';
  code?: string;
  accessToken?: string;
  error?: string;
}

export function readFacebookOAuthResult(value: unknown): FacebookOAuthResult | null {
  if (!value || typeof value !== 'object' || !('type' in value) || value.type !== 'facebook-oauth') return null;
  if ('error' in value && typeof value.error === 'string' && value.error.trim()) {
    return { type: 'facebook-oauth', error: value.error };
  }
  if ('code' in value && typeof value.code === 'string' && value.code.trim()) {
    return { type: 'facebook-oauth', code: value.code };
  }
  if ('accessToken' in value && typeof value.accessToken === 'string' && value.accessToken.trim()) {
    return { type: 'facebook-oauth', accessToken: value.accessToken };
  }
  return null;
}
